import { ProfitLoss } from '../../ProfitLoss';
import { computePercentage } from '../../../helpers/functions';
import { Icon } from '../../UI';

interface IDetailsView {
  isDetailsView?: boolean; // User has clicked the collection in 1 column view
  children?: any;
  withBorder?: boolean;
}

function getTextColor(isDetailsView: boolean) {
  return isDetailsView ? 'text-grey-50' : 'text-black';
}

function NFTspanWithIcon({
  children,
  isDetailsView = false,
  withBorder = false,
}: IDetailsView) {
  return (
    <div
      className={`
        flex
        items-center
        ${
          withBorder &&
          ` border-l
            border-grey-10
            dark:border-grey-70
          `
        }
        pl-2
        w-full
        h-full
        ${getTextColor(isDetailsView)}
        dark:bg-grey-90
        dark:text-white
      `}
    >
      {children && <span>Ξ</span>}
      {children || <div>-</div>}
    </div>
  );
}

function NFTAddress({
  children,
  isDetailsView = false,
  blockchain,
  address,
}: IDetailsView & {
  blockchain: string;
  address: string;
}) {
  return (
    <div
      className={`
        border-l
        border-grey-10
        dark:border-grey-70
        font-semibold
        flex
        items-center
        gap-2
        cursor-pointer
        ${getTextColor(isDetailsView)}
        dark:bg-grey-90
        dark:text-white
        w-full
        h-full
        pl-2
      `}
      onClick={() =>
        window.open(
          `https://opensea.io/assets/${blockchain.toLowerCase()}/${address}`,
          '_blank'
        )
      }
    >
      {children.slice(0, 3) + '...' + children.slice(-3)}
      <Icon svgName="openInNew" />
    </div>
  );
}

function NFTBlockchain({ isDetailsView = false }: IDetailsView) {
  return (
    <div
      className={'flex items-center gap-1 dark:bg-grey-90 w-full h-full ml-2'}
    >
      <img src="/icons/eth.svg" alt="eth logo" />
      <span className={getTextColor(isDetailsView) + 'dark:text-white'}>
        {'Ethereum'}
      </span>
    </div>
  );
}

function NFTDiff({
  start,
  end,
  isDetailsView = false,
}: {
  start: number;
  end: number;
  isDetailsView?: boolean;
}) {
  return (
    <div
      className={`
        ${isDetailsView ? 'flex gap-2' : 'block'}
        w-full
        h-full
        dark:bg-grey-90
        border-l
        border-grey-10
        dark:border-grey-70
      `}
    >
      {!start || !end ? (
        <div className={'flex justify-center items-center h-full'}>-</div>
      ) : (
        <div className={'h-full flex flex-col justify-center gap-1'}>
          <NFTspanWithIcon isDetailsView={isDetailsView}>{end}</NFTspanWithIcon>
          <ProfitLoss
            className={'ml-2 mb-px'}
            percentage={computePercentage(start, end, 100)}
          />
        </div>
      )}
    </div>
  );
}

export { NFTAddress, NFTBlockchain, NFTspanWithIcon, NFTDiff };
